import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

export interface LDItemListProduct {
  imageUrl: string;
  name: string;
  outOfStock?: boolean;
  price: number;
  url: string;
}

export interface GetLDItemListSchemaArgs {
  currencyCode: CurrencyCode;
  highPrice: number | null;
  lowPrice: number | null;
  numberOfItems: number;
  pageTitle: string | null;
  pageUrl: string | null;
  products?: LDItemListProduct[];
}

export const getLDItemListSchema = ({
  currencyCode,
  highPrice,
  lowPrice,
  numberOfItems,
  pageTitle,
  pageUrl,
  products = [],
}: GetLDItemListSchemaArgs) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: pageTitle,
    url: pageUrl,
    numberOfItems,
    offers: {
      '@type': 'AggregateOffer',
      offerCount: String(numberOfItems),
      priceCurrency: currencyCode,
      ...(lowPrice ? { lowPrice: lowPrice.toFixed(2) } : {}),
      ...(highPrice ? { highPrice: highPrice.toFixed(2) } : {}),
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'GB',
        },
      },
    },
    ...(products.length
      ? {
          itemListOrder: 'https://schema.org/ItemListOrderAscending',
          itemListElement: products.map((product, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'Product',
              name: product.name,
              image: product.imageUrl,
              url: product.url,
              offers: {
                '@type': 'Offer',
                price: product.price.toFixed(2),
                priceCurrency: currencyCode,
                availability: product.outOfStock
                  ? 'https://schema.org/OutOfStock'
                  : 'https://schema.org/InStock',
              },
            },
          })),
        }
      : {}),
  };
};
